// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, initializeAuth, inMemoryPersistence } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Inicializar o Firebase
const app = initializeApp(firebaseConfig);

// Exportar o Firestore e o Auth
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Instância separada usada só para criar contas pelo admin.
// createUserWithEmailAndPassword loga no usuário criado; aqui isso não afeta
// a sessão principal (nem as escritas pendentes do Firestore).
const userCreationApp = initializeApp(firebaseConfig, "user-creation");
export const userCreationAuth = initializeAuth(userCreationApp, {
  persistence: inMemoryPersistence,
});
